import { render } from "./Verifed.vue?vue&type=template&id=297a9b11"
import script from "./Verifed.vue?vue&type=script&lang=js"
export * from "./Verifed.vue?vue&type=script&lang=js"

import exportComponent from "/home/douglas/Documents/Rwi/surefooted-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__